<div class="form-group" [ngClass]="{ 'has-danger': required}">
  <label class="form-control-label" [ngClass]="{ 'required-field-label': required }"> {{title}} </label>
  <h6 *ngIf="!required">{{'FORM_ITEM_UNKNOWN_MESSAGE' | translate}}</h6>
  <div class="form-control-feedback" *ngIf="required">
    {{'FORM_ITEM_UNKNOWN_VALIDATION_MESSAGE_REQUIRED' | translate}}
  </div>
</div>
